import styled from 'styled-components'
// components
import {
  Accordion as AccordionOrigin,
  AccordionSummary as AccordionSummaryOrigin,
  AccordionDetails as AccordionDetailsOrigin
} from '@mui/material'

const DropContainer = styled.div`
  min-height: 400px;
`

const Accordion = styled(AccordionOrigin)<any>`
  && {
    box-shadow: none;
    margin-top: 16px;

    & > div > div {
      font-size: 15px;
      margin: 0;
    }

    & > div > :last-child {
      left: -6px;
    }

    :before {
      display: none;
    }
  }
`

const AccordionSummary = styled(AccordionSummaryOrigin)`
  && {
    min-height: 26px !important;

    flex-direction: row-reverse;
    font-size: 16px;
    padding: 0;

    & > :last-child {
      margin: 0;
      padding: 0;

      & > div {
        margin-left: 8px;
      }
    }
  }
`

const AccordionDetails = styled(AccordionDetailsOrigin)`
  && {
    flex-direction: column;
    font-size: 15px;
    justify-content: space-between;
    padding: 0;
  }
`

export { DropContainer, Accordion, AccordionSummary, AccordionDetails }
